import styled from "styled-components";

const UIWidgetsCustomCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  z-index: 2;
  position: relative;
  top: 6px;
  opacity: 0;
  cursor: pointer;
  width: ${props => props.theme.size16};
  height: ${props => props.theme.size16};
  & + div {
    display: block;
    color: rgb(255, 255, 255);
    opacity: 0.5;
    text-align: center;
    position: relative;
    width: ${props => props.theme.size16};
    height: ${props => props.theme.size16};
    z-index: 1;
    cursor: pointer;
    top: -12px;
    font-size: ${props => props.theme.font12};
    background: ${props => props.theme.grey};
  }
  &:checked + div {
    background: ${props =>
      props.background ? props.background : props.theme.darkYellow};
    opacity: 1;
  }
`;

export default UIWidgetsCustomCheckbox;
